import React from 'react';

export default function ShortDivider() {
  return (
    <div
      className="ui divider"
      style={{
        width: '3rem',
      }}
    />
  );
}
